import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b80950e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home__show" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "show__wrapper" }
const _hoisted_4 = { class: "show__couple" }
const _hoisted_5 = { class: "couple_left" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "couple_right" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#follow",
  class: "couple_join"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "79",
    height: "99",
    viewBox: "0 0 79 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.34",
      d: "M63.6414 78.1909C50.4414 96.1909 35.6414 98.6909 30.1414 98.6909C14.2534 98.6909 5.00494 80.5053 4.64143 66.6911C-0.85845 66.6911 -1.53845 46.8765 4.64143 45.1911C-1.8584 8.69107 46.6416 -17.3093 64.6414 15.1909C85.1414 17.1909 78.1414 46.6909 72.6414 57.1909C81.1662 57.1909 72.2621 83.3633 63.6414 78.1909Z",
      fill: "#111111"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.1",
      d: "M51.6641 56.1704H41.1641V67.2329H36.5391V56.1704H26.0703V51.8267H36.5391V40.7642H41.1641V51.8267H51.6641V56.1704Z",
      fill: "white"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", {
      class: "show__header",
      innerHTML: _ctx.t('Home.show.title')
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        href: "#follow",
        class: "show__button",
        innerHTML: _ctx.t('Home.show.join')
      }, null, 8, ["innerHTML"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: require('@/assets/man.png'),
            alt: "Приложении для поиска любимого человека"
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: require('@/assets/woman.png'),
            alt: "Приложении для поиска любимого человека"
          }, null, 8, _hoisted_8)
        ]),
        _hoisted_9
      ])
    ])
  ]))
}